export const SBER_QR_DEEPLINKS_ANDROID =
  'intent://ru.sberbankmobile/payments/services/qr,' +
  'android-app://ru.sberbankmobile/payments/services/qr,' +
  'sberbankonline://payments/services/qr';

export const SBER_QR_DEEPLINKS_IOS = [
  'onlineios-app://sbolonline/payments/open-barcodescanner',
  'startonline://sbolonline/payments/open-barcodescanner',
  'onlineappmobile://sbolonline/payments/open-barcodescanner',
  'sbolonline://sbolonline/payments/open-barcodescanner',
  'btripsexpenses://sbolonline/payments/open-barcodescanner',
  'budgetonline-ios://sbolonline/payments/open-barcodescanner',
  'sbolidexternallogin://sbolonline/payments/open-barcodescanner',
  'ios-app-smartonline://sbolonline/payments/open-barcodescanner',
  'app-online-ios://sbolonline/payments/open-barcodescanner',
].join(',');
